/* eslint-disable */
import React from 'react';
import moment from 'moment';
import { PublicPageFooterProps } from './types';

function PublicPageFooter(props: PublicPageFooterProps) {

  const { deviceInfo, ipAddress, updatedDate } = props;

  const { browser = "" } = deviceInfo ? JSON.parse(deviceInfo) : {}

  return (
    <div className="text-secondary text-xs relative bottom-2 left-0 right-0 text-center">
      {ipAddress}<span className="font-semibold">&nbsp;on&nbsp;</span>{updatedDate}
      {
        browser ?
          <><span className="font-semibold">&nbsp;with&nbsp; </span>
            {browser} </>
          : null
      }
    </div>
  );
}

export default PublicPageFooter;
